import {
  cycleCountIdFormat,
  cycleCountPlanIdFormat,
  cycleCountRuleIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import {
  storageLocationIdFormat,
  taskIdFormat,
} from "@redotech/redo-warehouse-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import {
  cycleCountSourceSchema,
  cycleCountStatusSchema,
} from "./list-cycle-counts";

const lineItem = z.object({
  planId: cycleCountPlanIdFormat.schema,
  /** Null for a bin with nothing on hand, which the counter fills in. */
  productId: productIdFormat.schema.nullable(),
  title: z.string().nullable(),
  sku: z.string().nullable(),
  /** Null when nothing is on hand yet, so the counter picks the bin. */
  storageLocationId: storageLocationIdFormat.schema.nullable(),
  storageLocationName: z.string().nullable(),
  expectedCount: z.int(),
  finalCount: z.int().nullable(),
  unitCost: z.number().nullable(),
});

export const getCycleCount = unaryRpc({
  name: "getCycleCount" as const,
  input: z.object({ id: cycleCountIdFormat.schema }),
  output: z.object({
    id: cycleCountIdFormat.schema,
    taskId: taskIdFormat.schema.nullable(),
    name: z.string().nullable(),
    status: cycleCountStatusSchema,
    source: cycleCountSourceSchema,
    locationId: locationIdFormat.schema,
    locationName: z.string(),
    cycleCountRuleId: cycleCountRuleIdFormat.schema.nullable(),
    ruleName: z.string().nullable(),
    assignedRole: z.string().nullable(),
    assignedUserId: z.string().nullable(),
    dueAt: z.date().nullable(),
    createdAt: z.date(),
    completedAt: z.date().nullable(),
    lines: z.array(lineItem),
  }),
});
